export const dateStringToDate = (dateString) => {
  if (!dateString.match(/^\d{2}\.\d{2}\.\d{4}$/i)) {
    console.error(`Date string ${dateString} is not in the format dd.mm.yyyy`);
    return new Date('Invalid Date');
  }
  const [day, month, year] = dateString.split('.');
  return new Date(`${year}-${month}-${day}`);
};
